export default __webpack_public_path__ + "static/media/022-expander.5b9c50f8.svg";